import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import ShopMainProdList from 'components/containers/commerce/main/StoreMainProdList'
import StoreMainBanner from 'components/containers/commerce/main/StoreMainBanner'

import TitleHeader from 'components/presenters/header/TitleHeader'
import TutorialButton from 'components/presenters/commerce/banner/TutorialBanner'

export default function CommerceMainLayout() {
  const history = useHistory()

  const onBack = () => {
    history.push('/')
  }

  return (
    <ShopMainWrapper>
      <HeaderWrapper>
        <TitleHeader title={'모티샵'} isNotiBtn={true} onBackBtn={onBack} />
      </HeaderWrapper>
      <BodyWrapper>
        <BannerBlock>
          <StoreMainBanner />
        </BannerBlock>
        <ContentBlock>
          <GuideBtnBlock>
            <TutorialButton />
          </GuideBtnBlock>
          <TitleBlock>
            <Title>건강하게 먹자. 더 싸게!</Title>
            <SubTitle>오픈기념! 파격적인 할인율은 곧 마감돼요 💣</SubTitle>
          </TitleBlock>
          <ShopMainProdList />
        </ContentBlock>
      </BodyWrapper>
    </ShopMainWrapper>
  )
}

const ShopMainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`

const HeaderWrapper = styled.div`
  flex: 0 1 auto;
  min-height: calc(100vw * (59.68 / 375));
  height: calc(100vw * (60 / 375));
`

const BodyWrapper = styled.div`
  flex: 1 1 auto;
  height: 100%;
  padding-bottom: calc(100vw * (61 / 375));
  overflow-y: scroll;
`

const BannerBlock = styled.div`
  min-height: calc(100vw * (360 / 375));
  margin-bottom: calc(100vw * (24 / 375));
`

const ContentBlock = styled.div`
  padding: 0 calc(100vw * (17 / 375));
`

const GuideBtnBlock = styled.div`
  margin-bottom: calc(100vw * (32 / 375));
`

const TitleBlock = styled.div`
  margin-bottom: calc(100vw * (22 / 375));
`

const Title = styled.h1`
  font-size: calc(100vw * (20 / 375));
  font-weight: 700;
  line-height: calc(100vw * (28 / 375));
  margin-bottom: calc(100vw * (5 / 375));
`

const SubTitle = styled.p`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (17 / 375));
  color: #7f7f7f;
`
